import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
    cached: {},
}

export const getters = {}

export const mutations = {
    // EUROCOUPONS_THIRDPARTY(state, euroCouponsTypes) {
    //     state.cached = euroCouponsTypes
    // },
}

export const actions = {

    init({ state, dispatch }) { },

    fetchEuroCouponsTypes(context, query) {
        query = query || ''
        return axios.get(`${serverUrl}/euro_coupons/coupon_types/${query}`).then((response) => {
            const request = response.data
            return request
        })
    },

    fetchEuroCouponsTypesOptions(context, query) {
        query = query || ''
        return axios.get(`${serverUrl}/euro_coupons/coupon_types/options/${query}`).then((response) => {
            return response.data
        })
    },

    // fetchEuroCouponsCashRegisterThirdpartyOptions(context, query) {
    //     query = query || ''
    //     return axios.get(`${serverUrl}/euro_coupons/thirdparty/cash_register_options/${query}`).then((response) => {
    //         return response.data
    //     })
    // },

    // fetchEuroCouponsTypesDetail(context, url) {
    //     return axios.get(url).then((response) => {
    //         return response.data
    //     })
    // },

    createUpdateEuroCouponsTypes(context, payload) {
        let promise = null
        if (payload.url) {
            promise = axios.put(payload.url, payload)
        } else {
            promise = axios.post(`${serverUrl}/euro_coupons/coupon_types/`, payload)
        }
        return promise.then(
            (response) => {
                return response.data
            }
        )
    },
    deleteEuroCouponsTypes(context, permUrl) {
        let promise = null
        promise = axios.delete(permUrl)
        return promise.then(
            (response) => {
                return response.data
            }
        )
    }
}